unable to read source [project]/frontend/node_modules/src/ui/scanner/camera-zoom-ui.ts